import {Settings} from './settings';
import {useBootstrapData} from '../bootstrap-data/bootstrap-data-context';

export function useSettings(): Settings {
  const context = useBootstrapData();
  return context?.data?.settings || ({} as Settings);
}
